import {Inject, Injectable} from '@angular/core';
import {first, take} from "rxjs/operators";
import {CountedAndPaginated} from "../interface/response/counted-and-paginated";
import {HttpClient} from "@angular/common/http";
import {FilterService} from "./filter.service";
import {DOCUMENT} from "@angular/common";
import {IddTrainingTrainer} from "../interface/idd-training-trainer";
import {Observable, ReplaySubject, Subject} from "rxjs";
import {IddTraining} from "../interface/idd-training";
import {Meeting} from "../interface/meeting";
import {ListResponse} from "../interface/response/list-response";
import {Contract} from "../interface/contract";

@Injectable({
  providedIn: 'root'
})
export class IddTrainingTrainerService {

  public readonly iddTrainingTrainerListSubject: ReplaySubject<CountedAndPaginated<IddTrainingTrainer>> =
    new ReplaySubject<CountedAndPaginated<IddTrainingTrainer>>(1);
  private readonly iddTrainingTrainerNotCountedListSubject: ReplaySubject<ListResponse<IddTrainingTrainer>> = new ReplaySubject<ListResponse<IddTrainingTrainer>>(1);

  constructor(
    private httpClient: HttpClient,
    private filterService: FilterService,
    @Inject(DOCUMENT) private document: Document,
  ) { }
  // public loadList(): void {
  //   this.httpClient.get(`/rest/crm/idd-training-trainer` )
  //     .pipe(
  //       first()
  //     )
  //     .subscribe((result: CountedAndPaginated<IddTrainingTrainer>) => {
  //       this.iddTrainingTrainerListSubject.next(result);
  //     });
  //
  // }

  public loadList(page: number, pageSize: number, filters: object): void {
    this.httpClient.get(`/rest/crm/idd-training-trainer?page=${page + 1}&pageSize=${pageSize}&` + this.filterService.parseFilters(filters))
      .pipe(
        first()
      )
      .subscribe((result: CountedAndPaginated<IddTrainingTrainer>) => {
        this.iddTrainingTrainerListSubject.next(result);
      });
  }

  public loadNotCountedList(page: number, pageSize: number, filters: object, subject?: Subject<ListResponse<IddTrainingTrainer>>): void {
    this.httpClient
      .get(`/rest/crm/idd-training-trainer?disableCount=1&page=${page + 1}&pageSize=${pageSize}&` + this.filterService.parseFilters(filters))
      .pipe(take(1))
      .subscribe((result: ListResponse<IddTrainingTrainer>) => {
        if (subject) {
          subject.next(result);
        } else {
          this.iddTrainingTrainerNotCountedListSubject.next(result);
        }
      });
  }

  public getIddTrainingTrainerListSubject(): ReplaySubject<CountedAndPaginated<IddTrainingTrainer>> {
    this.loadList(0, 9999, {});
    return this.iddTrainingTrainerListSubject;
  }

  sendForm(formData: object, iddTrainingTrainerId: string): Observable<any> {
    if (!iddTrainingTrainerId) {
      return this.httpClient.post(`/rest/crm/idd-training-trainer`, formData)
        .pipe(take(1));
    } else {
      return this.httpClient.put(`/rest/crm/idd-training-trainer/${iddTrainingTrainerId}`, formData)
        .pipe(take(1));
    }
  }

  get(iddTrainingTrainerId: string): Observable<IddTrainingTrainer> {
    return this.httpClient.get(`/rest/crm/idd-training-trainer/${iddTrainingTrainerId}`)
      .pipe(first()) as Observable<IddTrainingTrainer>;
  }

}
